import { InlineListSection as InlineListSectionType } from '@sr/types';
import { useThemeUI } from 'theme-ui';
import { ResumeTheme } from '../common/base-theme';
import { getCalcSize } from '../common/calc-size';
import { Box, ListItem, SectionHeading } from '../common/ui';

const InlineListSection = ({ section }: { section: InlineListSectionType }) => {
  const theme = useThemeUI().theme as ResumeTheme;
  const calcSize = getCalcSize(theme.baseSize);
  const listItems = (section.list || '').split('\n');
  return (
    <>
      <Box
        as="section"
        variant="sectionContainer"
        sx={{
          display: 'flex',
          flexWrap: ['wrap', 'nowrap'],
          pageBreakInside: 'avoid',
        }}
      >
        <Box variant="leftColumn">
          <SectionHeading>{section.title}</SectionHeading>
        </Box>
        <List
          sx={{
            listStyle: 'none',
            margin: 0,
            padding: 0,
            flexGrow: 1,
          }}
        >
          {listItems.map((string, index) => (
            <ListItem
              key={index}
              sx={{
                display: 'inline-block',
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: 'accent1',
                color: 'accent1',
                padding: '5px 18px',
                marginRight: '3px',
                marginBottom: calcSize(0.75),
                fontSize: 14,
              }}
            >
              {string}
            </ListItem>
          ))}
        </List>
      </Box>
    </>
  );
};

function List(props: any) {
  return <Box as="ul" {...props} />;
}

export default InlineListSection;
